import React from 'react';
import bootstrap from '../css/bootstrap.min.css'
import styles from '../css/style.css';
import fontAwesome from '../css/font.awesome.css'
import logo from "../img/logo/logo1.png"
import {NavLink, useLocation} from "react-router-dom";
import {
    ABOUT_ROUTE,
    CATALOG_ROUTE, CATEGORY_BLOCK_HOUSE,
    CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER,
    CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL, CONTACT,
    INDEX_ROUTE, PHOTO_ROUTE
} from "../utils/consts";

const Menu = () => {
    const location = useLocation();
    const isProductPage = location.pathname === CATEGORY_BLOCK_HOUSE
                                    || location.pathname === CATEGORY_EDGED_BOARD
                                    || location.pathname === CATEGORY_EVRO_VAGONKA
                                    || location.pathname === CATEGORY_FLOOR_BOARD
                                    || location.pathname === CATEGORY_IMITATION_TIMBER
                                    || location.pathname === CATEGORY_PLANED_BLOCK
                                    || location.pathname === CATEGORY_PLANED_BOARD
                                    || location.pathname === CATEGORY_SHTIL
                                    || location.pathname.includes(CATALOG_ROUTE);
    return (
        <header>
            <div className="main_header header_five">
                <div className="header_top">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-4">
                                <div className="welcome-text">
                                    <p>
                                        <i className="icon-phone"></i>8(916)737-55-95
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <div className="welcome-text text-center">
                                    <p>
                                        <i className="icon-mail"></i>89852223295@mail.ru
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 text-right">
                                <div className="welcome-text">
                                    <p>
                                        <i className="icon-watch"></i>Пн-Пт с 09:00 до 19:00
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header_middle header_middle5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-4">
                                <div className="logo">
                                    <NavLink to={INDEX_ROUTE}><img src={logo} alt="Логотип" /></NavLink>
                                </div>
                            </div>
                            {/*main menu start*/}
                            <div className="col-lg-6 colm_none">
                                <div className="main_menu menu_position">
                                    <nav>
                                        <ul>
                                            <li><NavLink to={INDEX_ROUTE}>Главная</NavLink></li>
                                            <li><NavLink className={`${isProductPage && 'active'}`} to={CATEGORY_PLANED_BOARD}>Каталог<i className="fa fa-angle-down"></i></NavLink>
                                                <ul className="sub_menu pages">
                                                    <li><NavLink to={CATEGORY_PLANED_BOARD}>Доска строганная</NavLink></li>
                                                    <li><NavLink to={CATEGORY_PLANED_BLOCK}>Брусок строганный</NavLink></li>
                                                    <li><NavLink to={CATEGORY_EDGED_BOARD}>Доска обрезная</NavLink></li>
                                                    <li><NavLink to={CATEGORY_BLOCK_HOUSE}>Блок-Хаус</NavLink></li>
                                                    <li><NavLink to={CATEGORY_IMITATION_TIMBER}>Имитация бруса</NavLink></li>
                                                    <li><NavLink to={CATEGORY_SHTIL}>Штиль</NavLink></li>
                                                    <li><NavLink to={CATEGORY_FLOOR_BOARD}>Доска пола</NavLink></li>
                                                    <li><NavLink to={CATEGORY_EVRO_VAGONKA}>Евровагонка</NavLink></li>
                                                </ul>
                                            </li>
                                            <li><NavLink to={PHOTO_ROUTE}>Фото</NavLink></li>
                                            <li><NavLink to={ABOUT_ROUTE}>О нас</NavLink></li>
                                            <li><NavLink to={CONTACT}>Контакты</NavLink></li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            {/*main menu end*/}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Menu;